import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import ButtonBase from "@/components/buttons/ButtonBase.vue";
import InputLogin from "@/components/inputs/InputLogin.vue";
import { B_VARIANT, INPUT_TYPE } from "@/types/frontend/enums/bootstrapEnums";
import { LoginForm } from "@/types/frontend/eventTypes";

interface LoginInterfaceProps {
    forgotPw?: boolean;
}

interface LoginInterfaceEmits {
    (e: 'login', value: LoginForm): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginInterface',
  props: {
    forgotPw: { type: Boolean }
  },
  emits: ["login"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'login', value: LoginForm): void;
}), expose: any, slots: any, attrs: any }) {





const email = ref('');
const pw = ref('');

return { __sfc: true,emit, email, pw, ButtonBase, InputLogin, B_VARIANT, INPUT_TYPE }
}

})